(()=>{'use strict';
  if(window.__TDM_PDP_INTERACTIONS__)return;
  window.__TDM_PDP_INTERACTIONS__=true;

  const controllers=new Map();
  const reduceMotion=()=>window.matchMedia?.('(prefers-reduced-motion: reduce)').matches===true;
  const all=(selector,scope=document)=>Array.from(scope.querySelectorAll(selector));
  const one=(selector,scope=document)=>scope.querySelector(selector);
  const selfAndAll=(scope,selector)=>{
    const out=[];
    if(scope?.matches?.(selector))out.push(scope);
    if(scope?.querySelectorAll)out.push(...scope.querySelectorAll(selector));
    return out;
  };
  const smooth=()=>reduceMotion()?'auto':'smooth';
  function mount(el,setup){
    if(!el||controllers.has(el))return;
    try{
      const cleanup=setup(el)||(()=>{});
      controllers.set(el,cleanup);
    }catch(e){console.error('[TDM PDP interaction init]',e,el)}
  }
  function unmountScope(scope){
    for(const [el,cleanup] of [...controllers]){
      if(el===scope||scope?.contains?.(el)){
        try{cleanup()}catch(e){console.warn('[TDM PDP cleanup]',e)}
        controllers.delete(el);
      }
    }
  }
  function resizeObserver(el,fn,signal){
    if('ResizeObserver' in window){const ro=new ResizeObserver(fn);ro.observe(el);return()=>ro.disconnect()}
    window.addEventListener('resize',fn,{passive:true,signal});return()=>{};
  }
  function nearestIndex(container,items){
    if(!items.length)return 0;
    const left=container.scrollLeft;
    let best=0,dist=Infinity;
    items.forEach((item,i)=>{const d=Math.abs((item.offsetLeft||0)-left);if(d<dist){dist=d;best=i}});
    return best;
  }
  function goTo(container,items,index,behavior=smooth()){
    if(!items.length)return;
    const i=Math.max(0,Math.min(items.length-1,index));
    container.scrollTo({left:items[i].offsetLeft||0,behavior});
  }

  function initGallery(gal){
    const ac=new AbortController(),signal=ac.signal;
    const list=one('.sm-gal__list',gal),track=one('.sm-gal__track',gal),thumb=one('.sm-gal__bar',gal),thumbs=one('.sm-gal__thumbs',gal);
    // Slides 3+ llegan con data-src (sm-galeria.liquid / renderGallery): se cargan al primer gesto sobre la galería
    // o en tiempo ocioso, así la foto principal, las fuentes y el JS crítico no compiten con 5-6 fotos de 200 KB.
    const hydrate=()=>{gal.dataset.tdmGalHydrated='1';all('img[data-src]',gal).forEach(img=>{if(img.dataset.srcset)img.srcset=img.dataset.srcset;if(img.dataset.sizes)img.sizes=img.dataset.sizes;img.src=img.dataset.src;delete img.dataset.src;delete img.dataset.srcset;delete img.dataset.sizes})};
    ['pointerdown','touchstart','wheel','keydown'].forEach(t=>gal.addEventListener(t,hydrate,{passive:true,signal}));
    list?.addEventListener('scroll',hydrate,{passive:true,signal});
    (window.requestIdleCallback||(fn=>setTimeout(fn,2000)))(()=>{if(!signal.aborted)hydrate()},{timeout:3500});
    const zoom=one('.sm-gal__zoom',gal),dialog=one('[data-sm-gal-modal]',gal),modalBody=dialog&&one('[data-sm-gal-modal-body]',dialog),modalClose=dialog&&one('[data-sm-gal-modal-close]',dialog);
    if(!list)return()=>ac.abort();
    if(!list.hasAttribute('tabindex'))list.tabIndex=0;
    list.setAttribute('role','region');
    if(!list.getAttribute('aria-label'))list.setAttribute('aria-label','Galería de producto');

    const slides=()=>all('.sm-gal__slide',list);
    const miniButtons=()=>thumbs?all('.sm-gal__thumb',thumbs):[];
    const update=()=>{
      const items=slides(),idx=nearestIndex(list,items);gal.dataset.activeIndex=String(idx);
      miniButtons().forEach((b,i)=>b.setAttribute('aria-current',i===idx?'true':'false'));
      if(track&&thumb){
        const max=Math.max(0,list.scrollWidth-list.clientWidth);
        const free=Math.max(0,track.clientWidth-thumb.clientWidth);
        thumb.style.left=(max>0?Math.min(free,Math.max(0,(list.scrollLeft/max)*free)):0)+'px';
      }
    };
    list.addEventListener('scroll',update,{passive:true,signal});
    const stopResize=resizeObserver(list,update,signal);
    requestAnimationFrame(update);

    thumbs?.addEventListener('click',e=>{
      const b=e.target.closest('.sm-gal__thumb');if(!b||!thumbs.contains(b))return;
      goTo(list,slides(),Number(b.dataset.i)||0);
    },{signal});
    list.addEventListener('keydown',e=>{
      const items=slides();if(!items.length)return;
      const current=nearestIndex(list,items);
      let next=null;
      if(e.key==='ArrowRight')next=current+1;
      else if(e.key==='ArrowLeft')next=current-1;
      else if(e.key==='Home')next=0;
      else if(e.key==='End')next=items.length-1;
      if(next===null)return;e.preventDefault();goTo(list,items,next);
    },{signal});

    let dragging=false,startX=0,startLeft=0,pointerId=null;
    thumb?.addEventListener('pointerdown',e=>{
      const free=Math.max(0,(track?.clientWidth||0)-(thumb?.clientWidth||0));if(free<=0)return;
      dragging=true;pointerId=e.pointerId;startX=e.clientX;startLeft=thumb.offsetLeft||0;thumb.setPointerCapture?.(e.pointerId);e.preventDefault();
    },{signal});
    thumb?.addEventListener('pointermove',e=>{
      if(!dragging||e.pointerId!==pointerId)return;
      const free=Math.max(0,track.clientWidth-thumb.clientWidth),max=Math.max(0,list.scrollWidth-list.clientWidth);if(free<=0||max<=0)return;
      const x=Math.min(free,Math.max(0,startLeft+e.clientX-startX));thumb.style.left=x+'px';list.scrollLeft=(x/free)*max;
    },{signal});
    const stopDrag=e=>{if(!dragging)return;if(e&&pointerId!==null&&e.pointerId!==undefined&&e.pointerId!==pointerId)return;dragging=false;pointerId=null};
    thumb?.addEventListener('pointerup',stopDrag,{signal});thumb?.addEventListener('pointercancel',stopDrag,{signal});

    function closeZoom(){
      if(!dialog)return;
      try{if(dialog.open&&dialog.close)dialog.close();else dialog.removeAttribute('open')}catch{dialog.removeAttribute('open')}
      if(modalBody)modalBody.replaceChildren();
    }
    function openZoom(index){
      if(!dialog||!modalBody)return;
      const item=slides()[Math.max(0,Number(index)||0)];if(!item)return;
      const img=one('img',item),video=one('video',item);modalBody.replaceChildren();
      if(img){const clone=document.createElement('img');clone.src=img.currentSrc||img.src;clone.alt=img.alt||'';clone.decoding='async';modalBody.appendChild(clone)}
      else if(video){const clone=video.cloneNode(true);clone.autoplay=false;clone.loop=false;clone.controls=true;clone.preload='metadata';clone.removeAttribute('autoplay');modalBody.appendChild(clone);clone.load?.()}
      else return;
      try{dialog.showModal?dialog.showModal():dialog.setAttribute('open','')}catch{dialog.setAttribute('open','')}
      requestAnimationFrame(()=>modalClose?.focus?.({preventScroll:true}));
    }
    zoom?.addEventListener('click',()=>openZoom(Number(gal.dataset.activeIndex)||0),{signal});
    list.addEventListener('dblclick',e=>{const slide=e.target.closest('.sm-gal__slide');if(slide)openZoom(slides().indexOf(slide))},{signal});
    modalClose?.addEventListener('click',closeZoom,{signal});
    dialog?.addEventListener('click',e=>{if(e.target===dialog)closeZoom()},{signal});
    dialog?.addEventListener('close',()=>modalBody?.replaceChildren(),{signal});
    document.addEventListener('tdm:variant:change',()=>requestAnimationFrame(update),{signal});
    return()=>{ac.abort();stopResize();closeZoom()};
  }

  function initBeforeAfter(ad){
    const ac=new AbortController(),signal=ac.signal;
    const before=one('[data-sm-ad-antes]',ad),after=one('[data-sm-ad-despues]',ad),buttons=()=>all('.sm-ad__mini',ad);
    const activate=b=>{
      if(!b)return;
      if(before&&b.dataset.antes)before.src=b.dataset.antes;
      if(after&&b.dataset.despues)after.src=b.dataset.despues;
      buttons().forEach(x=>{const on=x===b;x.setAttribute('aria-current',on?'true':'false');x.setAttribute('aria-pressed',on?'true':'false')});
    };
    buttons().forEach((b,i)=>{b.setAttribute('aria-pressed',b.getAttribute('aria-current')==='true'?'true':'false');b.dataset.caseIndex=String(i)});
    ad.addEventListener('click',e=>{const b=e.target.closest('.sm-ad__mini');if(b&&ad.contains(b))activate(b)},{signal});
    ad.addEventListener('pointerenter',e=>{const b=e.target.closest?.('.sm-ad__mini');if(!b)return;[b.dataset.antes,b.dataset.despues].filter(Boolean).forEach(src=>{const im=new Image();im.src=src})},{capture:true,signal});
    ad.addEventListener('focusin',e=>{const b=e.target.closest?.('.sm-ad__mini');if(!b)return;[b.dataset.antes,b.dataset.despues].filter(Boolean).forEach(src=>{const im=new Image();im.src=src})},{signal});
    return()=>ac.abort();
  }

  function initResults(root){
    const ac=new AbortController(),signal=ac.signal;
    const tabs=all('.sm-rs__dia',root),arc=one('.sm-rs__arco',root),pct=one('.sm-rs__pct',root),label=one('.sm-rs__et',root),copy=one('.sm-rs__p',root),tablist=one('.sm-rs__dias',root),panel=one('.sm-rs__stats',root);
    if(!tabs.length||!arc)return()=>ac.abort();
    const radius=57,circ=2*Math.PI*radius;arc.style.strokeDasharray=String(circ);
    tablist?.setAttribute('role','tablist');panel?.setAttribute('role','tabpanel');panel?.setAttribute('aria-live','polite');
    const activate=(tab,focus=false)=>{
      if(!tab)return;
      tabs.forEach(t=>{const on=t===tab;t.classList.toggle('esta-activa',on);t.setAttribute('role','tab');t.setAttribute('aria-selected',on?'true':'false');t.tabIndex=on?0:-1});
      const value=Math.max(0,Math.min(100,Number(tab.dataset.pct)||0));arc.style.strokeDashoffset=String(circ-(value/100)*circ);
      if(pct)pct.textContent=value+'%';if(label)label.textContent=tab.dataset.etiqueta||'';if(copy){copy.textContent=tab.dataset.texto||'';copy.style.letterSpacing=(Number(tab.dataset.interletra)||0)+'px'}
      if(focus)tab.focus();
    };
    activate(tabs.find(t=>t.classList.contains('esta-activa'))||tabs[0]);
    root.addEventListener('click',e=>{const t=e.target.closest('.sm-rs__dia');if(t&&root.contains(t))activate(t)},{signal});
    tablist?.addEventListener('keydown',e=>{
      const current=Math.max(0,tabs.indexOf(document.activeElement));let idx=null;
      if(e.key==='ArrowRight'||e.key==='ArrowDown')idx=(current+1)%tabs.length;
      else if(e.key==='ArrowLeft'||e.key==='ArrowUp')idx=(current-1+tabs.length)%tabs.length;
      else if(e.key==='Home')idx=0;else if(e.key==='End')idx=tabs.length-1;
      if(idx===null)return;e.preventDefault();activate(tabs[idx],true);
    },{signal});
    root.__tdmActivateResult=activate;
    return()=>{delete root.__tdmActivateResult;ac.abort()};
  }

  function initFaq(root){
    const ac=new AbortController(),signal=ac.signal,items=all('.sm-f2__item',root);
    const openItem=item=>{
      items.forEach(it=>{const on=it===item;it.classList.toggle('esta-abierta',on);const b=one('.sm-f2__cab',it),p=one('.sm-f2__panel',it);b?.setAttribute('aria-expanded',on?'true':'false');p?.setAttribute('aria-hidden',on?'false':'true')});
    };
    items.forEach(it=>{const b=one('.sm-f2__cab',it),p=one('.sm-f2__panel',it);if(p){p.setAttribute('role','region');p.setAttribute('aria-hidden',it.classList.contains('esta-abierta')?'false':'true')}b?.setAttribute('aria-expanded',it.classList.contains('esta-abierta')?'true':'false')});
    root.addEventListener('click',e=>{const b=e.target.closest('.sm-f2__cab');if(!b||!root.contains(b))return;const item=b.closest('.sm-f2__item'),was=item.classList.contains('esta-abierta');openItem(was?null:item)},{signal});
    root.__tdmOpenFaq=openItem;
    return()=>{delete root.__tdmOpenFaq;ac.abort()};
  }

  function initComparison(root){
    const ac=new AbortController(),signal=ac.signal,caja=one('.sm-cp2__caja',root),track=one('.sm-cp2__pista',root),thumb=one('.sm-cp2__pulgar',root);if(!caja||!track||!thumb)return()=>ac.abort();
    caja.tabIndex=0;caja.setAttribute('role','region');if(!caja.getAttribute('aria-label'))caja.setAttribute('aria-label','Tabla comparativa, desplazable horizontalmente');
    const update=()=>{const max=Math.max(0,caja.scrollWidth-caja.clientWidth),ratio=caja.scrollWidth?Math.min(1,caja.clientWidth/caja.scrollWidth):1,width=Math.max(20,track.clientWidth*ratio);thumb.style.width=width+'px';const free=Math.max(0,track.clientWidth-width);thumb.style.left=(max>0?(caja.scrollLeft/max)*free:0)+'px'};
    caja.addEventListener('scroll',update,{passive:true,signal});caja.addEventListener('keydown',e=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;e.preventDefault();const step=Math.max(120,caja.clientWidth*.7);if(e.key==='Home')caja.scrollTo({left:0,behavior:smooth()});else if(e.key==='End')caja.scrollTo({left:caja.scrollWidth,behavior:smooth()});else caja.scrollBy({left:e.key==='ArrowRight'?step:-step,behavior:smooth()})},{signal});
    const stop=resizeObserver(caja,update,signal);requestAnimationFrame(update);return()=>{ac.abort();stop()};
  }

  function initSet(root){
    const ac=new AbortController(),signal=ac.signal,pista=one('[data-sm-pista]',root),prev=one('[data-sm-prev]',root),next=one('[data-sm-next]',root),dotsBox=one('[data-sm-puntos]',root),status=one('[data-sm-set-status]',root);if(!pista)return()=>ac.abort();
    const items=all('.sm-st__i',pista),quiet=reduceMotion();let timer=null,observer=null;
    if(dotsBox)dotsBox.replaceChildren();
    const dots=items.map((_,i)=>{if(!dotsBox)return null;const b=document.createElement('button');b.type='button';b.className='sm-st__punto';b.setAttribute('aria-label','Ir a '+(i+1));b.addEventListener('click',()=>{stop();goTo(pista,items,i)},{signal});dotsBox.appendChild(b);return b});
    const current=()=>nearestIndex(pista,items);
    const paint=()=>{const i=current();dots.forEach((d,k)=>d?.setAttribute('aria-current',k===i?'true':'false'))};
    const stop=()=>{if(timer){clearInterval(timer);timer=null}};
    const start=()=>{if(quiet||timer||items.length<2||document.hidden)return;timer=setInterval(()=>goTo(pista,items,(current()+1)%items.length),3000)};
    ['pointerdown','touchstart','wheel','focusin'].forEach(type=>root.addEventListener(type,stop,{passive:type!=='focusin',signal}));root.addEventListener('mouseenter',stop,{signal});
    prev?.addEventListener('click',()=>{stop();goTo(pista,items,(current()-1+items.length)%items.length)},{signal});next?.addEventListener('click',()=>{stop();goTo(pista,items,(current()+1)%items.length)},{signal});pista.addEventListener('scroll',paint,{passive:true,signal});
    pista.addEventListener('keydown',e=>{let i=current();if(e.key==='ArrowRight')i++;else if(e.key==='ArrowLeft')i--;else if(e.key==='Home')i=0;else if(e.key==='End')i=items.length-1;else return;e.preventDefault();stop();goTo(pista,items,(i+items.length)%items.length)},{signal});
    root.addEventListener('click',async e=>{
      const btn=e.target.closest('.sm-st__btn');if(!btn||!root.contains(btn))return;e.preventDefault();e.stopPropagation();const id=Number(btn.dataset.smAdd)||0;if(!id)return;
      const ps=window.TDMProductSync,variant=ps?.getSource?.()?.variants?.find(v=>Number(v.id)===id);
      if(variant){ps.selectVariant(id,{origin:'shade-guide'});window.smIrAlSelector?.();return}
      btn.disabled=true;btn.setAttribute('aria-busy','true');if(status){status.hidden=true;status.textContent=''}
      try{if(window.TDMCart?.addItems)await window.TDMCart.addItems([{id,quantity:1}],{open:true});else if(window.smcAgregarItems)await window.smcAgregarItems([{id,quantity:1}],{open:true});else throw new Error('Carrito lateral no disponible')}
      catch(err){console.error('[TDM set add]',err);if(status){status.textContent='No pudimos agregar este producto. Reintentá.';status.hidden=false}}
      finally{btn.disabled=false;btn.removeAttribute('aria-busy')}
    },{signal});
    document.addEventListener('visibilitychange',()=>{if(document.hidden)stop();else start()},{signal});
    if('IntersectionObserver' in window){observer=new IntersectionObserver(entries=>entries.forEach(entry=>entry.isIntersecting?start():stop()),{threshold:.4});observer.observe(root)}else start();
    const stopResize=resizeObserver(pista,paint,signal);requestAnimationFrame(paint);
    root.__tdmSelectSetBlock=item=>{const i=items.indexOf(item);if(i>=0){stop();goTo(pista,items,i,'auto')}};
    return()=>{stop();observer?.disconnect();stopResize();delete root.__tdmSelectSetBlock;ac.abort()};
  }

  function initSticky(root){
    const ac=new AbortController(),signal=ac.signal,btn=one('[data-sm-fl-add]',root),status=one('[data-sm-fl-error]',root);
    // Barra inteligente: sigue al CTA principal de sm-comprar con IntersectionObserver (sin umbrales en píxeles).
    // Oculta mientras el CTA está en pantalla o todavía no llegó; aparece apenas el CTA sale por arriba del viewport;
    // vuelve a ocultarse si el usuario sube y el CTA reaparece.
    const ioOk='IntersectionObserver' in window;
    let observer=null,target=null,raf=0;
    const show=on=>root.classList.toggle('esta-visible',!!on);
    const findTarget=()=>document.querySelector('[data-tdm-buy] [data-sm-atc]')||document.querySelector('[data-sm-atc]');
    const hasLayout=el=>!!el&&el.isConnected&&el.getClientRects().length>0;
    const aboveViewport=el=>el.getBoundingClientRect().bottom<=0;
    // Sin CTA medible (sección oculta en este breakpoint o navegador sin IO): la barra aparece tras un scroll razonable.
    const evaluate=()=>{raf=0;if(hasLayout(target)){if(!observer)show(aboveViewport(target));return}show(window.scrollY>Math.min(600,window.innerHeight*.8))};
    const schedule=()=>{if(!raf)raf=requestAnimationFrame(evaluate)};
    const onEntries=entries=>{const e=entries[entries.length-1];if(!e)return;if(!hasLayout(e.target)){schedule();return}show(!e.isIntersecting&&e.boundingClientRect.bottom<=(e.rootBounds?.top??0))};
    const observe=()=>{
      const next=findTarget();if(observer&&next===target&&next?.isConnected)return;
      observer?.disconnect();observer=null;target=next;
      if(ioOk&&target){observer=new IntersectionObserver(onEntries,{threshold:0});observer.observe(target)}
      schedule();
    };
    observe();
    window.addEventListener('scroll',schedule,{passive:true,signal});window.addEventListener('resize',schedule,{passive:true,signal});window.addEventListener('pageshow',()=>{observe();schedule()},{signal});
    document.addEventListener('shopify:section:load',()=>setTimeout(observe,0),{signal});
    btn?.addEventListener('click',async()=>{
      if(status){status.hidden=true;status.textContent=''}
      try{
        if(window.TDMProductSync?.addSelectedBundle){const result=await window.TDMProductSync.addSelectedBundle({button:btn,error:status});if(!result&&status&&!status.textContent){status.textContent='Revisá tu selección antes de continuar.';status.hidden=false}}
        else {const id=Number(btn.dataset.smFlAdd);if(!id)throw new Error('Variante no disponible');if(window.smcAgregarItems)await window.smcAgregarItems([{id,quantity:1}],{open:true});else throw new Error('Carrito lateral no disponible')}
      }catch(err){console.error('[TDM sticky]',err);if(status){status.textContent='No pudimos agregar el producto. Reintentá.';status.hidden=false}}
    },{signal});
    return()=>{if(raf)cancelAnimationFrame(raf);observer?.disconnect();observer=null;ac.abort()};
  }

  function initMarketingCtas(){
    const key=document.documentElement;if(controllers.has(key))return;
    const ac=new AbortController(),signal=ac.signal;
    const selector=['.sm-ad__btn','.sm-dg__btn','.sm-ga__btn','.sm-of__cta','.sm-of__link','.sm-ah__btn','[data-sm-ir-selector]'].join(',');
    function scrollToSelector(){
      const sec=document.querySelector('.tdh-sm-packs');if(!sec)return false;
      const headerGroup=document.querySelector('#header-group'),offset=(headerGroup?.getBoundingClientRect?.().height||0)+12,y=sec.getBoundingClientRect().top+window.scrollY-offset;
      window.scrollTo({top:Math.max(0,y),behavior:smooth()});
      const first=sec.querySelector('input[type=radio]:checked, input[type=radio], button, a');
      if(first)setTimeout(()=>first.focus?.({preventScroll:true}),reduceMotion()?0:350);
      return true;
    }
    window.smIrAlSelector=scrollToSelector;
    document.addEventListener('click',e=>{const t=e.target.closest?.(selector);if(!t||t.closest('.smc-raiz')||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey||e.button!==0)return;if(!scrollToSelector())return;e.preventDefault()}, {capture:true,signal});
    controllers.set(key,()=>{ac.abort();if(window.smIrAlSelector===scrollToSelector)delete window.smIrAlSelector});
  }

  function initScope(scope=document){
    initMarketingCtas();
    selfAndAll(scope,'[data-sm-gal]').forEach(el=>mount(el,initGallery));
    selfAndAll(scope,'[data-sm-ad]').forEach(el=>mount(el,initBeforeAfter));
    selfAndAll(scope,'.sm-rs').forEach(el=>mount(el,initResults));
    selfAndAll(scope,'.sm-f2').forEach(el=>mount(el,initFaq));
    selfAndAll(scope,'.sm-cp2').forEach(el=>mount(el,initComparison));
    selfAndAll(scope,'[data-sm-set]').forEach(el=>mount(el,initSet));
    selfAndAll(scope,'[data-sm-fl]').forEach(el=>mount(el,initSticky));
  }

  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',()=>initScope(document),{once:true}):initScope(document);
  document.addEventListener('shopify:section:load',e=>initScope(e.target));
  document.addEventListener('shopify:section:unload',e=>unmountScope(e.target));
  document.addEventListener('shopify:block:select',e=>{
    const target=e.target;
    const before=target.closest?.('[data-sm-ad]');if(before&&target.matches?.('.sm-ad__mini'))target.click();
    const result=target.closest?.('.sm-rs');if(result&&target.matches?.('.sm-rs__dia'))result.__tdmActivateResult?.(target);
    const faq=target.closest?.('.sm-f2');if(faq){const item=target.closest?.('.sm-f2__item');if(item)faq.__tdmOpenFaq?.(item)}
    const set=target.closest?.('[data-sm-set]');if(set){const item=target.closest?.('.sm-st__i');if(item)set.__tdmSelectSetBlock?.(item)}
  });

  window.TDMPDPInteractions={init:initScope,unmount:unmountScope,controllers};
})();
